const dataHora = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
});
const hora = new Intl.DateTimeFormat("pt-BR", { timeZone: "America/Sao_Paulo", hour: "2-digit", minute: "2-digit" });
const dataHoraAno = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
});
const numero = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 3 });

export const fmtDataHora = (v?: string | null) => (v ? dataHora.format(new Date(v)) : "");
export const fmtHora = (v?: string | null) => (v ? hora.format(new Date(v)) : "");
/** Data com ano e hora, para comprovantes. */
export const fmtDataHoraAno = (v?: string | null) => (v ? dataHoraAno.format(new Date(v)) : "");
/** Hoje no fuso de São Paulo, menos n dias, no formato do campo de data (aaaa-mm-dd). */
export const diaSP = (menosDias = 0) => new Date(Date.now() - 3 * 3600_000 - menosDias * 86_400_000).toISOString().slice(0, 10);
export const fmtNum = (v?: number | string | null) => (v === null || v === undefined || v === "" ? "" : numero.format(Number(v)));

export const nomeStatusPedido: Record<string, string> = {
  aguardando_separacao: "Na fila",
  aguardando_reposicao: "Sem saldo",
  em_onda: "Em onda",
  separado: "Aguardando conferência",
  em_conferencia: "Em conferência",
  divergencia: "Divergência",
  conferido: "Conferido",
  expedido: "Expedido",
  cancelado: "Cancelado",
};

export const nomeTipoLocal: Record<string, string> = {
  PICKING: "Picking",
  PACKING: "Packing",
  PULMAO: "Pulmão",
  RECEBIMENTO: "Recebimento",
  QUARENTENA: "Quarentena",
  DEFEITO: "Defeito",
  EMBALAGEM: "Embalagens",
  CARRINHO: "Carrinho",
  CONTENTOR: "Caixa preta",
  EXPEDICAO: "Expedição",
  DIVERGENCIA: "Divergência",
};

const fmtCm = (n: number | null | undefined) => (n == null ? "?" : String(n).replace(".", ","));

/** Medidas de caixa em cm (comprimento x largura x altura). */
export function medidas(c: { comprimento_cm?: number | null; largura_cm?: number | null; altura_cm?: number | null }): string {
  if (c.comprimento_cm == null && c.largura_cm == null && c.altura_cm == null) return "sem medidas";
  return `${fmtCm(c.comprimento_cm)} x ${fmtCm(c.largura_cm)} x ${fmtCm(c.altura_cm)} cm`;
}
